(function() {
    angular.module('emarket.commons').directive('emRadioButton', function() {
        var directive = {
            scope: {
                displayName: '@?',
                elements: '=',
                model: '=',
                translate: '=?',
                small: '=?'
            },
            templateUrl:'directives/em-radio-button/em.radio.button.tpl.html',
            link: function(scope, element, attr) {
                element.addClass('em-radio-button');

                if(attr.small !== undefined) {
                    element.addClass('em-radio-button--small');
                }
                scope.getDisplayName = function(element) {
                    var displayName;
                    if(scope.displayName) {
                        displayName = element[scope.displayName];
                    } else {
                        displayName = element;
                    }
                    return displayName;
                };
                scope.setValue = function(element) {
                    scope.model = element;
                };
            }
        };
        return directive;
    });
}());
